// Imports de librerías
import { Box3, Group, Raycaster, Vector2 } from 'three';
import gsap, { Power2, Power3, Power4 } from 'gsap';
import BezierEasing from 'bezier-easing';

// Imports internos
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Image from '../_app/cuchillo/3D/Image';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { isMobile, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import Header from '../layout/Header';


export default class BGMedia extends Group {
    _alpha = 1;
    get alpha() {
        return this._alpha;
    }

    set alpha(value) {
        this._alpha = value;
        const instance = this.getInstance();
       /* if (instance?.scroller) {
            instance.scroller._items.forEach(item => {
                item.image.material.uniforms.opacity.value = value;
            });
        }*/
    }
                
    constructor(dom) {
        super();

        this.dom = dom;
        this.items = [];
        this.total = 0;
        this.actual = null;
        this.isShow = false;
        
        this.load();        
    }

    load() {
        
        const temp = [...GetBy.selector("[data-bgmedia]", this.dom)];
        this.total = temp.length;
        
        for(let i=0;i<this.total;i++) {
            const item = new BGMedia__Item(temp[i]);
            this.add(item);
            this.items.push(item);
        }
    }

    show(__n) {
        if(this.actual != null) this.hide(this.actual);
        this.actual = __n;
        this.items[this.actual].show();
    }

    hide(__n = null) {
        if(__n == null) __n = this.actual;
        if(this.actual == null) return;
        this.items[__n].hide();
        this.actual = null;
    }

    resize() {
        for(let i=0;i<this.total;i++) {
            this.items[i].resize();
        }
    }

    dispose() {
        for(let i=0;i<this.total;i++) {
            this.remove(this.items[i]);
            this.items[i].dispose();
        }

        this.dom = null;
        this.items = null;
        this.total = null;
        this.actual = null;
        this.isShow = null;
    }
}


class BGMedia__Item extends Group {
    domImage;
    isShow = false;
    image;
    _alpha = 0;
    _z = 0;
    
    get alpha() { return this._alpha; }
    get z() { return this._z; }

    set alpha(value) {
        this._alpha = value;
        this.image.material.uniforms.opacity.value = value;
    }
    set z(value) {
        this._z = value;
        this.image.position.z = value;
    }
    
    constructor(__d) {
        super();
        this.domImage = GetBy.selector("span", __d)[0];

        this.image = new Image({dom:this.domImage, hasFreePosition:true});
        this.add(this.image);
        
        this.image.visible = false;
        this.alpha = 0;

        this.resize();
       
    }

    show() {
        if (this.isShow) return;

        gsap.killTweensOf(this);

        this.isShow = true;
        this.image.visible = true;
        this.image.play();
        
        this.z = 100;
        gsap.to(this, { alpha: 1, ease: Power2.easeInOut, duration: .4, delay:.0 });
        gsap.to(this, { z: 10, ease: Power4.easeOut, duration: .8 });
    }

    hide() {
        if (!this.isShow) return;

        gsap.killTweensOf(this);

        gsap.to(this, { alpha:0, z:0, ease: Power2.easeIn, duration: 0.3, delay:.1, onComplete:()=> {
            this.image.visible = false;
            this.image.stop();
        }});

        this.isShow = false;
    }

    dispose() {
        this.remove(this.image);
        this.image.stop();
        this.image.dispose();
        this.image = null;
        this.domImage = null;
        this.isShow = null;
        this.image = null;
        this._alpha = null;
        this._z = null;
    }

    resize() {            
        if(this.image) {            
            this.image.resize();
            this.image.position.x = 0;
            this.image.position.y = 0;
            this.image.position.z = 0;
        }
    }
}